/**
 * Workspace-link doc_type for persistence. `live_stream` documents (synthetic
 * anchors for streamed / Eventhouse-harvested tags) persist as 'timeseries' —
 * matching the link-time attach — so the historian document scope includes
 * anchors attached via Add-Files (round-2 audit: persisting 'live_stream'
 * dead-ended those tags for the agent).
 *
 * Lives in `lib/` rather than the board slice because RENDERERS need it too
 * (a freshly added anchor carries the raw type in its shape props, and must
 * still paint as a Time Series card on the first frame). Importing the zustand
 * slice from a presentational component drags the whole store into its module
 * graph — which breaks component tests that mock `@/store`. `store/boardSlice`
 * re-exports this so existing import sites are unchanged.
 */
// Overloads (review on #25305): callers that provide at least one concrete
// doc type get `string` back — no `as string` casts at persist sites — while
// the all-optional shape keeps `string | undefined` for loosely-typed rows.
export function persistedDocType(doc: { type: string; doc_type?: string }): string
export function persistedDocType(doc: { type?: string; doc_type: string }): string
export function persistedDocType(doc: { type?: string; doc_type?: string }): string | undefined
export function persistedDocType(doc: { type?: string; doc_type?: string }): string | undefined {
  const t = doc.type ?? doc.doc_type
  return t === 'live_stream' ? 'timeseries' : t
}
